<template>
  <div class="publication-member-item">
    <img
      :src="result.photo"
      alt="member-item"
      class="publication-member-item__image"
    >
    <h6 class="publication-member-item__name">{{result.name}}

    </h6>
    <span class="publication-member-item__position">
      {{result.position}}
    </span>
    <span class="publication-member-item__date">
      {{result.regDate.title}}: <time>{{result.regDate.value}}</time>
    </span>
    <div class="publication-member-bottom">
<!--      <span class="publication-member-bottom__count">
        <svg class="publication-member-bottom__icon" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.90945 7.36488C5.90945 7.89863 5.47676 8.33132 4.94301 8.33132C4.40925 8.33132 3.97656 7.89863 3.97656 7.36488C3.97656 6.83113 4.40925 6.39844 4.94301 6.39844C5.47676 6.39844 5.90945 6.83113 5.90945 7.36488Z" fill="#87929D"/>
          <path d="M11.9173 7.36488C11.9173 7.89863 11.4846 8.33132 10.9508 8.33132C10.4171 8.33132 9.98438 7.89863 9.98438 7.36488C9.98438 6.83113 10.4171 6.39844 10.9508 6.39844C11.4846 6.39844 11.9173 6.83113 11.9173 7.36488Z" fill="#87929D"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.71812 8.27734C1.71812 11.7467 4.53061 14.5592 8 14.5592C11.4694 14.5592 14.2819 11.7467 14.2819 8.27734C14.2819 4.80796 11.4694 1.99546 8 1.99546C4.53061 1.99546 1.71812 4.80796 1.71812 8.27734ZM8 0.277344C3.58172 0.277344 0 3.85907 0 8.27734C0 12.6956 3.58172 16.2773 8 16.2773C12.4183 16.2773 16 12.6956 16 8.27734C16 3.85907 12.4183 0.277344 8 0.277344Z" fill="#87929D"/>
          <path d="M11.2153 10.1432C11.4349 10.3338 11.4602 10.6688 11.2467 10.8661C10.8746 11.2098 10.4495 11.4929 9.98666 11.704C9.36376 11.988 8.68708 12.1349 8.00247 12.1347C7.31785 12.1345 6.64127 11.9871 6.01855 11.7027C5.55584 11.4913 5.1309 11.2079 4.75911 10.864C4.54567 10.6665 4.57121 10.3316 4.79092 10.1411C5.01063 9.95069 5.34099 9.97779 5.56047 10.1685C5.82917 10.402 6.13062 10.5963 6.45604 10.7449C6.94155 10.9667 7.46904 11.0816 8.00281 11.0818C8.53657 11.0819 9.06415 10.9674 9.5498 10.746C9.87531 10.5975 10.1769 10.4034 10.4457 10.1701C10.6653 9.97952 10.9957 9.95263 11.2153 10.1432Z" fill="#87929D"/>
        </svg>
        10/10
      </span>-->
      <span>
        {{result.countProjects}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicationMemberItem',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.publication-member-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  padding: 26px 16px 16px;
  &__image{
    display: block;
    border-radius: 50%;
    max-width: 100px;
    margin-bottom: 18px;
  }
  &__name{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #252425;
    margin-bottom: 3px;
  }
  &__position{
    font-size: 14px;
    line-height: 20px;
    color: #6367A7;
    text-align: center;
    margin-bottom: 6px;
  }
  &__date{
    font-size: 12px;
    line-height: 16px;
    color: #87929D;
    text-align: center;
    margin-bottom: 15px;
  }
}
.publication-member-bottom{
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  font-size: 12px;
  line-height: 16px;
  color: #87929D;
  &__count{
    display: flex;
    font-weight: 700;
  }
  &__icon{
    display: block;
    width: 16px;
    height: 16px;
    margin-right: 3px;
  }
}
</style>